import api from './api';

// Kullanıcı kaydı
export const register = async (userData) => {
    try {
        console.log('Kayıt verileri:', userData); // Gönderilen verileri konsola yazdır
        const response = await api.post('/users/register', userData);
        if (response.data.success) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    } catch (error) {
        console.error('Kayıt hatası:', error.response?.data || error.message || error);
        throw error;
    }
};

// Kullanıcı profilini güncelleme
export const updateUserProfile = async (profileData) => {
    try {
        const response = await api.put('/users/profile', profileData);
        if (response.data.success) {
            // Yerel depolanan kullanıcı bilgilerini güncelle
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const updatedUser = { ...currentUser, user: response.data.user };
            localStorage.setItem('user', JSON.stringify(updatedUser));
        }
        return response.data;
    } catch (error) {
        console.error('Profil güncelleme hatası:', error.response?.data || error.message || error);
        throw error;
    }
};

// Kullanıcı girişi
export const login = async (email, password) => {
  const response = await api.post('/users/login', { email, password });
  if (response.data.success) {
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

// Çıkış yapma
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Mevcut kullanıcı bilgisi
export const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('user'));
};

// Token kontrolü
export const isAuthenticated = () => {
  return localStorage.getItem('token') ? true : false;
};

// Kullanıcı profili
export const getUserProfile = async () => {
  const response = await api.get('/users/profile');
  return response.data;
};

// Şifre sıfırlama isteği gönder
export const requestPasswordReset = async (email) => {
    try {
        const response = await api.post('/users/forgot-password', { email });
        return response.data;
    } catch (error) {
        console.error('Şifre sıfırlama isteği hatası:', error.response?.data || error.message);
        throw error;
    }
};

// Şifre sıfırlama token'ını doğrula
export const verifyResetToken = async (token) => {
    try {
        const response = await api.get(`/users/verify-reset-token/${token}`);
        return response.data;
    } catch (error) {
        console.error('Token doğrulama hatası:', error.response?.data || error.message);
        throw error;
    }
};

// Yeni şifre belirle
export const resetPassword = async (token, newPassword) => {
    try {
        const response = await api.post('/users/reset-password', {
            token,
            password: newPassword
        });
        return response.data;
    } catch (error) {
        console.error('Şifre sıfırlama hatası:', error.response?.data || error.message);
        throw error;
    }
};